
require('angular').module('clientDashboardApp.reviewBuilder').directive('campaignLink', ['campaignLinkModal', function(campaignLinkModal) {
  return {
    restrict: 'A',
    scope: {
      "campaign": "=campaignLink"
    },
    link: function(scope, element) {
      element.on('click', () => campaignLinkModal.openModal(scope.campaign))
    }
  }
}])

require('angular').module('clientDashboardApp.reviewBuilder').factory('campaignLinkModal', ['$uibModal', '$location', function($uibModal, $location) {

  function openModal(campaign) {
    $uibModal.open({
      template: require("./campaignLinkModal.html"),
      size: "lg",
      controller: ['$scope', function($scope) {
        $scope.availableFields = [
          { label: "Name", value: "contact:name", description: "The name of the contact", example: "#NAME#" },
          { label: "Email Address", value: "contact:email", description: "The email address of the contact", example: "#EMAIL#" },
          { label: "Phone Number", value: "contact:phone", description: "The phone number of the contact", example: "#PHONE#" },
          { label: "Contact ID", value: "contact:remoteId", description: "The ID value of the contact in your system", example: "#ID#" },
          { label: "Location ID", value: "locationId", description: "The location ID in our system which you would like a review to be submitted for", example: "#LOCATION_ID#" },
        ]

        $scope.mergeTagDefn = "Depending on the type of mailing software you use, merge tags may also be known as personalization fields, substitution strings, or personalization tags. These tags allow you to insert data from your mailing list directly into your email campaigns."
        $scope.campaign = campaign

        $scope.url = function() {
          let campaignUrl = `${$location.protocol()}://${location.host}/reviewBuilder/form/submission/${campaign.formId}?campaignId=${campaign._id.$oid}`

          let selectedFields = $scope.availableFields.filter(field => field.mergeTag && field.mergeTag.trim())
          selectedFields.map(field => {
            campaignUrl += `&${encodeURIComponent(field.value)}=${field.mergeTag}`
          })
          return campaignUrl
        }

      }]
    })
  }

  return {openModal}
}])
